var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-statistic-container" },
    [
      _c(
        "div",
        { staticClass: "search-wrap", staticStyle: { position: "relative" } },
        [
          _c("div", { staticClass: "btn-group" }, [
            _c(
              "div",
              {
                staticClass: "btn",
                class: _vm.btnActive == -1 ? "btn-active" : "",
                on: {
                  click: function($event) {
                    return _vm.dateChange(-1)
                  }
                }
              },
              [_vm._v(" 昨日 ")]
            ),
            _c(
              "div",
              {
                staticClass: "btn",
                class: _vm.btnActive == 7 ? "btn-active" : "",
                on: {
                  click: function($event) {
                    return _vm.dateChange(7)
                  }
                }
              },
              [_vm._v(" 近7日 ")]
            ),
            _c(
              "div",
              {
                staticClass: "btn",
                class: _vm.btnActive == 30 ? "btn-active" : "",
                on: {
                  click: function($event) {
                    return _vm.dateChange(30)
                  }
                }
              },
              [_vm._v(" 近30日 ")]
            )
          ]),
          _c("el-date-picker", {
            staticStyle: { width: "240px", "margin-right": "12px" },
            attrs: {
              size: "mini",
              editable: false,
              type: "daterange",
              "value-format": "yyyy-MM-dd",
              "range-separator": "-",
              "start-placeholder": "统计时间",
              "end-placeholder": "统计时间",
              "picker-options": _vm.pickerOptions,
              clearable: ""
            },
            on: { change: _vm.selectTime },
            model: {
              value: _vm.searchSelectTime,
              callback: function($$v) {
                _vm.searchSelectTime = $$v
              },
              expression: "searchSelectTime"
            }
          }),
          _c(
            "span",
            {
              staticClass: "tip",
              attrs: { slot: "reference" },
              on: {
                click: function($event) {
                  return _vm.openTipDialog(1)
                }
              },
              slot: "reference"
            },
            [_vm._v("统计说明 "), _c("i", { staticClass: "el-icon-question" })]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "card-wrap" },
        _vm._l(_vm.topDataList, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "card-item",
              class: { isClick: item.path && item.isGo },
              on: {
                click: function($event) {
                  return _vm.clickItem(item)
                }
              }
            },
            [
              _c("img", {
                staticClass: "item-icon",
                attrs: { src: item.icon, alt: "" }
              }),
              _c("div", { staticClass: "item-data" }, [
                _c("div", { staticClass: "data-title" }, [
                  _vm._v(_vm._s(item.text))
                ]),
                _c("div", { staticClass: "data-num" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card-content",
                      style: { color: item.color }
                    },
                    [_vm._v(" " + _vm._s(item.value) + " ")]
                  ),
                  item.path && item.isGo
                    ? _c("i", { staticClass: "el-icon-arrow-right card-icon" })
                    : _vm._e()
                ])
              ])
            ]
          )
        }),
        0
      ),
      _c("div", { staticClass: "zhe-xian-wrap" }, [
        _c("div", { staticClass: "zhe-xian-title" }, [
          _vm._m(0),
          _c(
            "div",
            {
              staticClass: "title-name-wrap",
              on: {
                click: function($event) {
                  _vm.showCustomBtn ? _vm.addCustomerShow() : ""
                }
              }
            },
            [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showCustomBtn,
                      expression: "showCustomBtn"
                    }
                  ],
                  staticClass: "title-more",
                  staticStyle: { "margin-left": "-80px" }
                },
                [
                  _vm._v("更多"),
                  _c("i", { staticClass: "el-icon-arrow-right" })
                ]
              )
            ]
          )
        ]),
        _c("div", {
          staticStyle: { width: "100%", height: "277px" },
          attrs: { id: "zheXiangTu" }
        }),
        _vm._m(1)
      ]),
      _c("div", { staticClass: "bottom-wrap" }, [
        _c("div", { staticClass: "chat-survey-wrap" }, [
          _c("div", { staticClass: "head-wrap" }, [
            _c("div", { staticClass: "chat-title" }, [
              _c("div", { staticClass: "title-left" }, [
                _c(
                  "div",
                  {
                    staticClass: "chat-overview",
                    on: { click: _vm.chatClick }
                  },
                  [
                    _c("span", { staticClass: "title-name" }, [
                      _vm._v("聊天概况")
                    ]),
                    _vm._m(2)
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "tip",
                    on: {
                      click: function($event) {
                        return _vm.openTipDialog(2)
                      }
                    }
                  },
                  [
                    _vm._v("统计说明 "),
                    _c("i", { staticClass: "el-icon-question" })
                  ]
                )
              ]),
              _c("div", { staticClass: "title-right" }, [
                _c(
                  "div",
                  {
                    staticClass: "title-btn",
                    class: _vm.chatParams.judge == 1 ? "btn-activ" : "",
                    on: {
                      click: function($event) {
                        return _vm.changeChat(1)
                      }
                    }
                  },
                  [_vm._v(" 聊天总数 ")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "title-btn",
                    class: _vm.chatParams.judge == 2 ? "btn-activ" : "",
                    on: {
                      click: function($event) {
                        return _vm.changeChat(2)
                      }
                    }
                  },
                  [_vm._v(" 发消息数 ")]
                )
              ])
            ]),
            _c("div", { staticClass: "chat-body" }, [
              _c("div", { staticClass: "body-li" }, [
                _c(
                  "span",
                  {
                    staticClass: "li-title",
                    attrs: { slot: "reference" },
                    slot: "reference"
                  },
                  [_vm._v("平均首次回复时长")]
                ),
                _c("div", { staticClass: "li-count-wrap" }, [
                  _c("span", { staticClass: "li-count" }, [
                    _vm._v(_vm._s(_vm.avgReplyTimeCount))
                  ]),
                  _c("span", { staticClass: "li-unit" }, [_vm._v("min")])
                ])
              ])
            ])
          ]),
          _c("div", { attrs: { id: "chat-survey" } })
        ]),
        _c("div", { staticClass: "staff-rank-wrap" }, [
          _c("div", { staticClass: "head-wrap" }, [
            _c("div", { on: { click: _vm.customerStatisticsShow } }, [
              _c("span", { staticClass: "title-name" }, [_vm._v("员工概况")]),
              _vm._m(3)
            ]),
            _c("span", { staticClass: "tip" }, [
              _vm._v("(本表为历史数据总和，不受页面左上角时间控制)")
            ])
          ]),
          _c("div", { staticClass: "table-wrap" }, [
            _c(
              "div",
              { staticClass: "table-data" },
              [
                _c(
                  "el-table",
                  {
                    ref: "singleTable",
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      "font-size": "13px"
                    },
                    attrs: {
                      size: "medium",
                      "header-cell-style": {
                        background: "#eef1f6",
                        color: "#606266"
                      },
                      "highlight-current-row": true,
                      data: _vm.staffRankData,
                      "default-sort": {
                        prop: "bindDangAnCount",
                        order: "descending"
                      },
                      height: "353px"
                    },
                    on: { "sort-change": _vm.customerSortChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "序号", width: "65", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.pageparm.pageSize *
                                      (_vm.pageparm.currentPage - 1) +
                                      (scope.$index + 1)
                                  ) +
                                  " "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "userName",
                        label: "员工姓名",
                        "min-width": "88",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "bindDangAnCount",
                        sortable: "custom",
                        label: "绑定档案数",
                        "min-width": "88",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "bindCusCount",
                        sortable: "custom",
                        label: "绑定客户数",
                        "min-width": "88",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "friendNumb",
                        sortable: "custom",
                        label: "好友总数",
                        "min-width": "88",
                        align: "center"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "staff-pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    "current-page": _vm.pageparm.currentPage,
                    "page-size": _vm.pageparm.pageSize,
                    layout: "prev, pager, next, jumper",
                    total: _vm.pageparm.total
                  },
                  on: {
                    "current-change": _vm.callBack,
                    "update:currentPage": function($event) {
                      return _vm.$set(_vm.pageparm, "currentPage", $event)
                    },
                    "update:current-page": function($event) {
                      return _vm.$set(_vm.pageparm, "currentPage", $event)
                    }
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _c("StatisticDialog", { ref: "tipDialog" }),
      _c("addCustomer", { ref: "addCustomer" }),
      _c("customerStatistics", { ref: "customerStatistics" }),
      _c("customerContact", { ref: "customerContact" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-name-wrap" }, [
      _c("span", { staticClass: "title-name" }, [_vm._v("新增客户波动")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flag-color" }, [
      _c("div", { staticClass: "line-type" }, [
        _c("div", { staticClass: "type-item" }, [
          _c("div", { staticClass: "dot xin-zeng-dot" }),
          _c("div", { staticClass: "type-name" }, [_vm._v("新增客户")])
        ]),
        _c("div", { staticClass: "type-item" }, [
          _c("div", { staticClass: "dot xin-bang-dot" }),
          _c("div", { staticClass: "type-name" }, [_vm._v("新绑档案")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "title-more" }, [
      _vm._v("更多"),
      _c("i", { staticClass: "el-icon-arrow-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "title-more" }, [
      _vm._v("更多"),
      _c("i", { staticClass: "el-icon-arrow-right" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }